export default "__VITE_ASSET__CUNU9Hyq__"